export const NON_SUPPORTED_LANGUAGES = ['hi', 'ar', 'he', 'fi'];
export const BI_MICRO_CATEGORIES_CLICK_SOURCE = 'explore_more_tags';
